import AppLayout from '@/layout/AppLayout.vue';
import PublicLayout from '@/layout/PublicLayout.vue';
import { useAuthStore } from '@/stores/auth.store';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/info',
            component: PublicLayout,
            children: [
                {
                    path: 'contact',
                    name: 'contact',
                    component: () => import('@/views/ContactView.vue'),
                    meta: {
                        showSidebar: false,
                        requiresAuth: false
                    }
                },
                {
                    path: 'support',
                    name: 'support',
                    component: () => import('@/views/PublicSupportView.vue'),
                    meta: {
                        showSidebar: false,
                        requiresAuth: false
                    }
                }
            ],
            meta: {
                showSidebar: false,
                requiresAuth: false
            }
        },
        {
            path: '/admin',
            component: AppLayout,
            children: [
                {
                    path: 'events',
                    name: 'events',
                    component: () => import('@/views/AdminEventsView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresAdmin: true
                    }
                },
                {
                    path: 'events/:id',
                    name: 'event-settings',
                    component: () => import('@/views/AdminEventsView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresAdmin: true
                    }
                },
                {
                    path: 'exhibitors',
                    name: 'exhibitors',
                    component: () => import('@/views/AdminExhibitorsView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresAdmin: true
                    }
                },
                {
                    path: 'users',
                    name: 'users',
                    component: () => import('@/views/UsersView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresStaff: true
                    }
                },
                {
                    path: 'sync-events',
                    name: 'sync-events',
                    component: () => import('@/views/AdminSyncEventsView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresAdmin: true
                    }
                },
                {
                    path: 'sync-history',
                    name: 'sync-history',
                    component: () => import('@/views/AdminSyncHistoryView.vue'),
                    meta: {
                        showSidebar: true,
                        requiresAdmin: true
                    }
                }
            ],
            meta: {
                showSidebar: true,
                requiresAuth: true
            }
        },
        {
            path: '/',
            name: 'home',
            component: AppLayout,
            children: [
                {
                    path: 'event-support',
                    name: 'event-support',
                    component: () => import('@/views/SupportView.vue'),
                },
                {
                    path: '',
                    name: 'dashboard',
                    component: () => import('@/views/DashboardView.vue'),
                    meta: {
                        showSidebar: false,
                        requiresAuth: true
                    }
                },
                {
                    path: 'momentus/:id',
                    name: 'momentus',
                    component: () => import('@/views/MomentusView.vue'),
                    meta: {
                        showSidebar: false,
                        requiresAuth: true
                    }
                },
                {
                    path: 'axess/:id',
                    name: 'axess',
                    component: () => import('@/views/AxessView.vue'),
                    meta: {
                        showSidebar: false,
                        requiresAuth: true
                    }
                }
            ],
            meta: {
                showSidebar: false,
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach(async (to) => {
    const auth = useAuthStore();


    if (to.meta.requiresAuth && !auth.isAuthenticated) {
        //await auth.ensureUserIsLoggedIn();
    }

    if (to.matched.some(r => r.meta.requiresAdmin)) {
        if (!auth.isAdmin()) {
            return auth.isEmployee() ? { path: '/admin/users' } : { path: '/' };
        }
    } else if (to.matched.some(r => r.meta.requiresStaff)) {
        if (!auth.isAdmin() && !auth.isEmployee()) {
            return { path: '/' };
        }
    }

    // No redirect for public routes — anyone can view them.
});

export default router;
